export enum NodeType {
  Folder,
  Item
}
